
import ButtonGroups from '@/components/UntitledUI/ButtonGroups/ButtonGroups.vue'
import ButtonGroup from '@/components/UntitledUI/ButtonGroups/ButtonGroup.vue'
export default {
    name: 'Pagination',
    components: {
        ButtonGroup,
        ButtonGroups
    },
    props: {
        totalAmount: Number,
        value: Number,
        size: {
            type: Number,
            default: 10
        },
        range: {
            type: Number,
            default: 2
        }
    },
    computed: {
        pages () {
            if (this.totalAmount <= this.size) {
                return [1]
            }

            let start = 1
            if (this.value - this.range > 0) {
                start = this.value - this.range
            }

            let end = this.lastPage
            if (this.value + this.range <= this.lastPage) {
                end = this.value + this.range
            }

            const numbers = []
            for (let i = start; i <= end; i++) {
                numbers.push(i)
            }

            return numbers
        },
        lastPage () {
            if (this.totalAmount <= this.size) {
                return 1
            }

            let pages = Math.floor(this.totalAmount / this.size)
            if ((this.totalAmount % this.size) !== 0) {
                pages++
            }
            return pages
        }
    },
    methods: {
        pageClicked (page) {
            this.$emit('input', page)
        },
        next () {
            if (this.value + 1 > this.lastPage) { return }
            this.$emit('input', this.value + 1)
        },
        before () {
            if (this.value - 1 <= 0) { return }
            this.$emit('input', this.value - 1)
        }
    }
}
